import clsx from 'clsx';

interface LabelProps {
  text?: string;
  className?: string;
  children: React.ReactNode;
}

export const Label = ({ text, className, children }: LabelProps) => {
  if (!text) return <>{children}</>;

  return (
    <div className={clsx('space-y-1', className)}>
      <label className="block text-sm font-medium text-gray-700">{text}</label>
      {children}
    </div>
  );
};
